// React&NextJS
import React, { useContext } from 'react'
import Head from 'next/head'
// 3rd party libraries
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// Styles
import s from './GallerySlider.module.scss'
import classnames from 'classnames'
// Components
import { Image } from '../../core/image/Image'
import { useLongPress } from '../../../hooks/useLongPress/useLongPress'
import { UIContext } from '../../../context/UIContext'

const c = classnames.bind(s)

type Props = {
    gallery: Array<string> | Array<File>
    style: 'memory' | 'obituary'
    disabled?: boolean
    setShowModal?: Function
    setIndex?: Function
}

export default function GallerySlider({
    gallery,
    style,
    disabled,
    setShowModal,
    setIndex,
}: Props) {
    const { uiState, setUIState } = useContext(UIContext)

    const onLongPress = () => {
        // console.log(e, 'longpress is triggered')
    }

    const onClick = (e: React.BaseSyntheticEvent) => {
        setUIState({ ...uiState, canScroll: false })
        //showModal variable to true
        setShowModal((prev) => !prev)
        // Set index from selected image(event) to open in gallery.tsx
        setIndex(parseInt(e.target.id))
    }

    const longPressProps = useLongPress(onLongPress, onClick)

    const getURL = (img: File | string) => {
        if (typeof img === 'string') {
            return img
        } else {
            return URL.createObjectURL(img)
        }
    }

    // settigs depending on gallery in memory, obituary or fullscreen
    const settings = {
        className: c('variable-width', s.slider),
        dots: false,
        infinite: false,
        centerMode: false,
        speed: 500,
        centerPadding: '60px',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        variableWidth: true,
        focusOnSelect: false,
        swipeToSlide: true,
        accessibility: false,
    }

    if (!gallery.length) {
        return <></>
    }
    return (
        <div>
            <Head>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
            </Head>
            <div
                className={c(
                    s.gallery,
                    s[`${style}`],
                    disabled && s['disabled']
                )}
            >
                <Slider {...settings}>
                    {gallery?.map((image: string | File, i) => (
                        <div key={i}>
                            {!disabled && (
                                <Image
                                    src={getURL(image)}
                                    height={234}
                                    alt=""
                                    id={i}
                                    lazy
                                    {...longPressProps}
                                />
                            )}
                            {disabled && (
                                <Image
                                    src={getURL(image)}
                                    height={234}
                                    alt=""
                                    lazy
                                    id={i}
                                />
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}
